import manifestJson from "./socialImageManifest.json";

const manifest: Record<string, { src: string; width: number; height: number }> =
  manifestJson;

/** Optimized social previews; retain existing WebP when a conversion would be larger. */
export function socialImageSrc(src: string): string {
  const absolute = src.startsWith("https://nordiskauterum.se/");
  const path = absolute ? src.slice("https://nordiskauterum.se".length) : src;
  const result = manifest[path]?.src;
  return result
    ? absolute
      ? `https://nordiskauterum.se${result}`
      : result
    : src;
}
